/* eslint-disable jsx-a11y/alt-text */
/* eslint-disable react/no-unknown-property */
/* eslint-disable @next/next/no-img-element */
import React, { useState } from 'react';
import Style from './EnergiaSolarEconomia.css';
import ContainerHome24 from '@/components/atoms/ContainerHome24';
import CustomEmblaCarouselHome24 from '../CustomEmblaCarouselHome24';
import RedButton from '@/components/atoms/RedButton';

function EnergiaSolarEconomia() {
  const [width, setWidth] = useState(typeof window === 'undefined' ? 0 : window.window.innerWidth);
  if (typeof window === 'undefined') {
    console.log('');
  } else {
    window.addEventListener('resize', function () {
      setWidth(window.window.innerWidth);
    });
  }
  return (
    <>
      <section id="energia-solar-economia">
        <div className="energia-solar-economia-p1">
          <ContainerHome24>
            <div className="economia-textos">
              <img
                src="assets/energia-solar/ic_services_sustainable.svg"
                alt="icone"
                className="economia-textos-icone"
              />
              <h2 className="economia-textos-titulo">
                Economia na sua conta com energia limpa e acessível
              </h2>
              {typeof window === 'undefined' ? (
                <></>
              ) : (
                <>
                  {width < 992 && (
                    <picture>
                      <source type="image/webp" srcSet="assets/energia-solar/img-economia.webp" />
                      <source type="image/png" srcSet="assets/energia-solar/img-economia.png" />
                      <img
                        src="assets/energia-solar/img-economia.png"
                        alt="Casa com painel solar no telhado, financiado por Santander, resultando em economia na conta de luz através do uso da energia solar."
                      />
                    </picture>
                  )}
                </>
              )}
              <p className="economia-textos-texto">
                A energia solar é uma fonte sustentável de energia renovável e também uma opção
                muito econômica. Além disso, oferece alta qualidade e segurança em sua utilização.
                <br />
                <br />
                Transforme seu projeto em realidade com o <b>Energia Santander</b>. Você garante
                acesso as melhores taxas do mercado, um prazo de carência de até 120 dias e a
                tranquilidade de um projeto realizado por especialistas.
              </p>
              <RedButton className="economia-textos-btn" href="#energia-solar-parceiros">
                Tenho interesse
              </RedButton>
            </div>
            {typeof window === 'undefined' ? (
              <></>
            ) : (
              <>
                {width >= 992 && (
                  <picture>
                    <source
                      type="image/webp"
                      srcSet="assets/energia-solar/img-economia-desk.webp"
                    />
                    <source type="image/png" srcSet="assets/energia-solar/img-economia-desk.png" />
                    <img
                      src="assets/energia-solar/img-economia-desk.png"
                      alt="Casa com painel solar no telhado, financiado por Santander, resultando em economia na conta de luz através do uso da energia solar."
                    />
                  </picture>
                )}
              </>
            )}
          </ContainerHome24>
        </div>
        <div className="energia-solar-economia-p2">
          <ContainerHome24>
            <h2 className="vantagens-titulo">Vantagens para o seu bolso</h2>
            <div>
              <CustomEmblaCarouselHome24
                // loop
                enableBullets
                detectBulletCount
                hideOverflow
                enableMobileArrows
                enablePrevArrow
                //autoplay={100000}
              >
                {({ className }) => (
                  <>
                    <div className={`slide ${className}`}>
                      <img src="assets/energia-solar/vantagens/ic_savings_account.svg" alt="" />
                      <p className="slide-texo">
                        Redução de até 95%
                        <br />
                        na conta de energia
                      </p>
                    </div>
                    <div className={`slide ${className}`}>
                      <img src="assets/energia-solar/vantagens/ic_bank_credit.svg" alt="" />
                      <p className="slide-texo">
                        Créditos na conta
                        <br />
                        de luz
                      </p>
                    </div>
                    <div className={`slide ${className}`}>
                      <img src="assets/energia-solar/vantagens/ic_home.svg" alt="" />
                      <p className="slide-texo">
                        Valorização
                        <br />
                        do imóvel
                      </p>
                    </div>
                    <div className={`slide ${className}`}>
                      <img src="assets/energia-solar/vantagens/ic_payment_summary.svg" alt="" />
                      <p className="slide-texo">
                        Tarifas fixas, sem <br />
                        reajustes anuais
                      </p>
                    </div>
                    <div className={`slide ${className}`}>
                      <img src="assets/energia-solar/vantagens/ic_schedule_spending.svg" alt="" />
                      <p className="slide-texo">
                        Financie com mais
                        <br />
                        prazo, em até 8 anos
                      </p>
                    </div>
                  </>
                )}
              </CustomEmblaCarouselHome24>
            </div>
          </ContainerHome24>
        </div>

        <div className="energia-solar-separador">
          <CustomEmblaCarouselHome24
            // loop
            enableBullets
            detectBulletCount
            hideOverflow
            enableMobileArrows
            enablePrevArrow
            autoplay={100000}
          >
            {({ className }) => (
              <>
                <div className={`slide ${className}`}>
                  {typeof window === 'undefined' ? (
                    <></>
                  ) : (
                    <>
                      {width <= 992 && (
                        <picture className="img-separador-vantagens">
                          {/* <source type="image/webp" srcSet="assets/energia-solar/vantagens/separador-vantagens-1.webp" /> */}
                          <source
                            type="image/png"
                            srcSet="assets/energia-solar/vantagens/separador-vantagens-1.png"
                          />
                          <img
                            src="assets/energia-solar/vantagens/separador-vantagens-1.png"
                            alt="Pessoas felizes em ter placas solares com durabilidades de até 25 anos, com painel solar no fundo."
                          />
                        </picture>
                      )}
                      {width > 992 && (
                        <picture className="img-separador-vantagens">
                          {/* <source type="image/webp" srcSet="assets/energia-solar/vantagens/separador-vantagens-1-desk.webp" /> */}
                          <source
                            type="image/png"
                            srcSet="assets/energia-solar/vantagens/separador-vantagens-1-desk.png"
                          />
                          <img
                            src="assets/energia-solar/vantagens/separador-vantagens-1-desk.png"
                            alt="Pessoas felizes em ter placas solares com durabilidades de até 25 anos, com painel solar no fundo."
                          />
                        </picture>
                      )}
                    </>
                  )}
                </div>
                <div className={`slide ${className}`}>
                  {typeof window === 'undefined' ? (
                    <></>
                  ) : (
                    <>
                      {width <= 992 && (
                        <picture className="img-separador-vantagens">
                          {/* <source type="image/webp" srcSet="assets/energia-solar/vantagens/separador-vantagens-2.webp" /> */}
                          <source
                            type="image/png"
                            srcSet="assets/energia-solar/vantagens/separador-vantagens-2.png"
                          />
                          <img
                            src="assets/energia-solar/vantagens/separador-vantagens-2.png"
                            alt="Painéis solares capturando a luz solar para gerar energia elétrica de forma eficiente."
                          />
                        </picture>
                      )}
                      {width > 992 && (
                        <picture className="img-separador-vantagens">
                          {/* <source type="image/webp" srcSet="assets/energia-solar/vantagens/separador-vantagens-2-desk.webp" /> */}
                          <source
                            type="image/png"
                            srcSet="assets/energia-solar/vantagens/separador-vantagens-2-desk.png"
                          />
                          <img
                            src="assets/energia-solar/vantagens/separador-vantagens-2-desk.png"
                            alt="Painéis solares capturando a luz solar para gerar energia elétrica de forma eficiente."
                          />
                        </picture>
                      )}
                    </>
                  )}
                </div>
                <div className={`slide ${className}`}>
                  {typeof window === 'undefined' ? (
                    <></>
                  ) : (
                    <>
                      {width <= 992 && (
                        <picture className="img-separador-vantagens">
                          {/* <source type="image/webp" srcSet="assets/energia-solar/vantagens/separador-vantagens-3.webp" /> */}
                          <source
                            type="image/png"
                            srcSet="assets/energia-solar/vantagens/separador-vantagens-3.png"
                          />
                          <img
                            src="assets/energia-solar/vantagens/separador-vantagens-3.png"
                            alt="Painéis solares instalados no telhado de um edifício, vistos de cima."
                          />
                        </picture>
                      )}
                      {width > 992 && (
                        <picture className="img-separador-vantagens">
                          {/* <source type="image/webp" srcSet="assets/energia-solar/vantagens/separador-vantagens-3-desk.webp" /> */}
                          <source
                            type="image/png"
                            srcSet="assets/energia-solar/vantagens/separador-vantagens-3-desk.png"
                          />
                          <img
                            src="assets/energia-solar/vantagens/separador-vantagens-3-desk.png"
                            alt="Painéis solares instalados no telhado de um edifício, vistos de cima."
                          />
                        </picture>
                      )}
                    </>
                  )}
                </div>
              </>
            )}
          </CustomEmblaCarouselHome24>
        </div>
      </section>
      <style jsx>{Style}</style>
    </>
  );
}

export default EnergiaSolarEconomia;
